import React from 'react'
import { useSelector } from 'react-redux';
import { selectListItems } from '../../../../../../redux/library/selector';
import { AccordionContainer } from '../../../../../../common/components/accordion/accordion.module';
import { InputContainer } from '../../../../../../common/components/form/input/containers/input.container';



export default function OnboardRoleSpecificInfoComponent ({handleFormChange, subscriptionDetails}: any) {
  const libraryData = useSelector(selectListItems)
  const registeredUsers: any = [
    { Description: 'Less than 10', Value: 10 },
    { Description: '10-50', Value: 20 },
    { Description: '50-100', Value: 30 },
    { Description: 'Greater than 100', Value: 40 },
  ]
  const POS: any = [
    { Description: 'Less than 10', Value: 10 },
    { Description: '10-50', Value: 20 },
    { Description: '50-100', Value: 30 },
    { Description: '100-200', Value: 40 },
    { Description: '200-500', Value: 50 },
    { Description: 'More than 500', Value: 50 },
  ]
  return (
    <>
      <AccordionContainer
    child={
      <div className=' grid md:grid-cols-3 lg:grid-cols-4 gap-4'>
<InputContainer
     label="Cities with maximum sellers" 
     labelField="Cities with maximum sellers"
    //  list={cities}
     onValueChange={( newValue: any) => {
       const countryData: any = newValue.map((option: any) => option?.value || '')
       handleFormChange({
        value: countryData,
        field: 'SellerNP_MSNModel.Top3CitiesWithMaximumSeller',
        data: subscriptionDetails?.SellerNP_MSNModel
      });
     }}
     type="multiselect"
     valueField="Id"
     value={subscriptionDetails?.SellerNP_MSNModel?.Top3CitiesWithMaximumSeller}
 />
<InputContainer
                 label="Active Registered Sellers"
               labelField="Description"
                     list={registeredUsers}
                     onValueChange={(event: any) => {
                      handleFormChange({
                        value: event.target.value,
                        field: 'SellerNP_MSNModel.ActiveRegisteredSellers',
                        data: subscriptionDetails?.SellerNP_MSNModel
                      });
                     }}
                     optionName='Choose Registered Sellers'
                     type="select"
                     value={subscriptionDetails?.SellerNP_MSNModel?.ActiveRegisteredSellers}
                     valueField="Description"
             />
 <InputContainer
     label="Categories" 
     labelField="Description"
     list={libraryData?.result?.TopCategoryOfProductServices}
     onValueChange={( newValue: any) => {
       const countryData: any = newValue.map((option: any) => option?.value || '')
       handleFormChange({
        value: countryData,
        field: 'SellerNP_MSNModel.TopCategoryOfProductService',
        data: subscriptionDetails?.SellerNP_MSNModel
      });
     }}
     type="multiselect"
     valueField="Description"
     value={subscriptionDetails?.SellerNP_MSNModel?.TopCategoryOfProductService}
 />


  </div>
  }
  expandedPanel="Seller NP - MarketPlace Seller mode (MSN)"
  headerTitle="Seller NP - MarketPlace Seller mode (MSN)"
/>
<AccordionContainer
    child={
        <div className=' grid md:grid-cols-3 lg:grid-cols-4 gap-4'>
      <InputContainer
     label="No of POS or Store" 
     labelField="Description"
     list={POS}
     onValueChange={( newValue: any) => {
       const countryData: any = newValue.map((option: any) => option?.value || '')
       handleFormChange({
        value: countryData,
        field: 'SellerNP_ISNModel.NoOfPOSOrStore',
        data: subscriptionDetails?.SellerNP_ISNModel
      });
     }}
     type="multiselect"
     valueField="Description"
     value={subscriptionDetails?.SellerNP_ISNModel?.NoOfPOSOrStore}
 />
       
         <InputContainer
             label="Top Category Of ProductService" 
             labelField="Description"
             list={libraryData?.result?.TopCategoryOfProductServices}
             onValueChange={( newValue: any) => {
               const countryData: any = newValue.map((option: any) => option?.value || '')
               handleFormChange({
                value: countryData,
                field: 'SellerNP_ISNModel.TopCategoryOfProductService',
                data: subscriptionDetails?.SellerNP_ISNModel
              });
             }}
             type="multiselect"
             valueField="Description"
             value={subscriptionDetails?.SellerNP_ISNModel?.TopCategoryOfProductService}
         />
        
        
          </div>
  }
  expandedPanel="Seller NP - Inventory Seller mode (ISN)"
  headerTitle="Seller NP - Inventory Seller mode (ISN)"
/>


        </>
  )
}